var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "box",
    [
      _c(
        "localize",
        {
          attrs: {
            tag: "p",
            resource: _vm.Resources.Account.ContinueAsGuestDescription,
          },
        },
        [
          _c("span", { attrs: { "format-key": "0" } }, [
            _vm._v(_vm._s(_vm.platformName)),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.actionUrl
        ? _c(
            "base-button",
            {
              staticClass: "_my-3 _w-100",
              attrs: {
                theme: "accent",
                shape: "soft",
                "data-qa": "continue-as-guest-button:ContinueAsGuest",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.Resources.Account.ContinueAsGuestButtonLabel) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "_mb-3 _mt-0" }, [
        _vm._v(_vm._s(_vm.Resources.Account.ContinueAsGuestBenefitsListHeader)),
      ]),
      _vm._v(" "),
      _c("continue-as-guest-account-benefit-list"),
      _vm._v(
        "\n    " +
          _vm._s(_vm.Resources.Account.ContinueAsGuestBenefitMoreLabel) +
          "\n    "
      ),
      _c("progress-overlay", { attrs: { visible: _vm.isProcessing } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }